export const Ai = (flujax) => ({
  async chatPrompt (promptWithHistory) {
    return flujax.post('/ai/chat/prompt', promptWithHistory)
  },

  async interject (interjection) {
    return flujax.post('/ai/chat/prompt/interject', interjection)
  },

  async chatPromptPlanType (planType, item) {
    return flujax.post(`/ai/chat/${planType}`, item)
  },

  async balance () {
    return flujax.post('ai/chat/balance')
  },

  async slash () {
    return flujax.post('ai/chat/slash')
  },

  async htmlTemplate (templateRequest) {
    return flujax.post('ai/chat/html/template', templateRequest)
  },

  async promptFeedback (prompt) {
    return flujax.post('ai/chat/prompt/feedback', prompt)
  },

  async htmlResize (payload) {
    return flujax.post('ai/chat/creative/html/resize', payload)
  },

  async htmlAdjust (payload) {
    return flujax.post('ai/chat/creative/html/adjust', payload)
  },

  async session () {
    return flujax.get('ai/chat/session')
  },

  async getSession (sessionId) {
    return flujax.get(`ai/chat/session/${sessionId}`)
  },

  async getInstructions () {
    return flujax.get('ai/instruction/get')
  },

  async getInstruction (instructionId) {
    return flujax.get(`ai/instruction/${instructionId}`)
  },

  async setInstructionVersionStatus (instructionId, versionData) {
    return flujax.post(`ai/instruction/${instructionId}/version`, versionData)
  },

  async createOrUpdateInstruction (instructionRequest) {
    return flujax.post('ai/instruction/post', instructionRequest)
  },

  async executeInstruction (executionRequest) {
    return flujax.post('ai/instruction/async/execute', executionRequest)
  }
})
